import React from "react";
import { FormField } from "../../SignUpFormTypes/signUpFormTypes";
import EmailInput from "./CustomInputs/EmailInput/EmailInput";
import OfferInput from "./CustomInputs/OfferInput/OfferInput";
import QuestionsInput from "./CustomInputs/QuestionInput/QuestionsInput";
import FirstNameInput from "./CustomInputs/FirstNameInput";
import LastNameInput from "./CustomInputs/LastNameInput";
import PasswordInput from "./CustomInputs/PasswordInput/PasswordInput";
import ProfessionInput from "./CustomInputs/ProfessionInput/ProfessionInput";
import PhoneInput from "./CustomInputs/PhoneInput/PhoneInput";
import AgreementInput from "./CustomInputs/AgreementInput";

const FormFields: React.FC<{ fields?: FormField[] }> = ({ fields }) => {
  const fieldsOpts = {
    agreement: AgreementInput,
    email: EmailInput,
    firstName: FirstNameInput,
    lastName: LastNameInput,
    password: PasswordInput,
    phone: PhoneInput,
    profession: ProfessionInput,
    questions: QuestionsInput,
    offer: OfferInput,
  };

  const fieldsList =
    fields &&
    fields.map((item, index) => {
      const Field = fieldsOpts[item?.field];
      const isQuestion = item?.field === "questions";
      const questionAttributes = item.questionAttributes;

      return (
        <Field
          key={
            isQuestion
              ? `${item.field}-${item.questionAttributes?.questionName}`
              : item.field
          }
          {...(isQuestion && item.questionAttributes
            ? { ...questionAttributes, index }
            : { index })}
          offerOne={item?.offerAttributesOne}
          offerTwo={item?.offerAttributesTwo}
          defaultOfferOne={item?.defaultOfferOne}
        />
      );
    });

  return <>{fieldsList}</>;
};

export default FormFields;
